// models/metrics/metasearchMetrics/tripadvisor-meta/tripadvisorMetaMetrics.js

// connectivity
import MetricMaybeAvailableRate from "models/metrics/metasearchMetrics/tripadvisor-meta/connectivity/MetricMaybeAvailableRate";
import MetricNotAvailableRate from "models/metrics/metasearchMetrics/tripadvisor-meta/connectivity/MetricNotAvailableRate";

// conversion
import MetricBookingCountTripadvisor from "models/metrics/metasearchMetrics/tripadvisor-meta/conversion/MetricBookingCount";
import MetricConversionTripadvisor from "models/metrics/metasearchMetrics/tripadvisor-meta/conversion/MetricConversion";
import MetricPaidClicks from "models/metrics/metasearchMetrics/tripadvisor-meta/conversion/MetricPaidClicks";
import MetricRevenuePerclickTripadvisor from "models/metrics/metasearchMetrics/tripadvisor-meta/conversion/MetricRevenuePerclick";
import MetricRoiTripadvisor from "models/metrics/metasearchMetrics/tripadvisor-meta/conversion/MetricRoi";

// performance
import MetricBeatRate from "models/metrics/metasearchMetrics/tripadvisor-meta/performance/MetricBeatRate";
import MetricClicksTripadvisor from "models/metrics/metasearchMetrics/tripadvisor-meta/performance/MetricClicks";
import MetricClicksShare from "models/metrics/metasearchMetrics/tripadvisor-meta/performance/MetricClickShare";
import MetricCpcTripadvisor from "models/metrics/metasearchMetrics/tripadvisor-meta/performance/MetricCpc";
import MetricCsrTripadvisor from "models/metrics/metasearchMetrics/tripadvisor-meta/performance/MetricCsr";
import MetricCtrTripadvisor from "models/metrics/metasearchMetrics/tripadvisor-meta/performance/MetricCtr";
import MetricHotelClicksTripadvisor from "models/metrics/metasearchMetrics/tripadvisor-meta/performance/MetricHotelsClicks";
import MetricMeetRate from "models/metrics/metasearchMetrics/tripadvisor-meta/performance/MetricMeetRate";
import MetricSpentTripadvisor from "models/metrics/metasearchMetrics/tripadvisor-meta/performance/MetricSpent";
import MetricPlmMiss from "models/metrics/metasearchMetrics/tripadvisor-meta/performance/MetricPlmMiss";
import MetricImpr from "models/metrics/metasearchMetrics/tripadvisor-meta/performance/MetricImpr";

// visibility
import MetricAbsTopImprShare from "models/metrics/metasearchMetrics/tripadvisor-meta/visibility/MetricAbsTopImprShare";
import MetricAvgPosCount from "models/metrics/metasearchMetrics/tripadvisor-meta/performance/MetricAvgPosCount";
import MetricEligImpr from "models/metrics/metasearchMetrics/tripadvisor-meta/visibility/MetricEligImpr";
import MetricImprShare from "models/metrics/metasearchMetrics/tripadvisor-meta/performance/MetricImprShare";
import MetricAbsTopImpr from "./visibility/MetricAbsTopImpr";
import MetricLoseRate from "models/metrics/metasearchMetrics/tripadvisor-meta/visibility/MetricLoseRate";
import MetricMissedImprBidTooLow from "models/metrics/metasearchMetrics/tripadvisor-meta/visibility/MetricMissedImprBidTooLow";
import MetricOpportunities from "models/metrics/metasearchMetrics/tripadvisor-meta/visibility/MetricOpportunityCount";

// others
import MetricAvgDay2Arrival from "models/metrics/metasearchMetrics/tripadvisor-meta/others/MetricAvgDay2Arrival";
import MetricAvgGuests from "models/metrics/metasearchMetrics/tripadvisor-meta/others/MetricAvgGuests";
import MetricAvgLos from "models/metrics/metasearchMetrics/tripadvisor-meta/others/MetricAvgLos";

const tripadvisorMetaMetrics = [
    // connectivity
    new MetricMaybeAvailableRate(),
    new MetricNotAvailableRate(),
    // conversion
    new MetricBookingCountTripadvisor(),
    new MetricConversionTripadvisor(),
    new MetricPaidClicks(),
    new MetricRevenuePerclickTripadvisor(),
    new MetricRoiTripadvisor(),
    // performance
    new MetricBeatRate(),
    new MetricClicksTripadvisor(),
    new MetricClicksShare(),
    new MetricCpcTripadvisor(),
    new MetricCsrTripadvisor(),
    new MetricCtrTripadvisor(),
    new MetricHotelClicksTripadvisor(),
    new MetricImpr(),
    new MetricImprShare(),
    new MetricMeetRate(),
    new MetricSpentTripadvisor(),
    new MetricPlmMiss(),
    // visibility
    new MetricAbsTopImpr(),
    new MetricAbsTopImprShare(),
    new MetricAvgPosCount(),
    new MetricEligImpr(),
    new MetricLoseRate(),
    new MetricMissedImprBidTooLow(),
    new MetricOpportunities(),
    // others
    new MetricAvgDay2Arrival(),
    new MetricAvgGuests(),
    new MetricAvgLos(),
];

export function findMetricById(metricId) {
    return tripadvisorMetaMetrics.find((metricClass) => metricClass.field === metricId);
}

export default tripadvisorMetaMetrics;
